// Set webpack asset host at runtime. Must be imported at top of entrypoints.
import '../helpers/asset_host';
import App from '../packages/partners_signup/App';
import reactRender from '../helpers/react_render';

const reactRoot = document.getElementById('react-root');

reactRender(App, {
  domains: JSON.parse(reactRoot.dataset.domains),
  isTofuSurveyExperimentEnabled: JSON.parse(reactRoot.dataset.isTofuSurveyExperimentEnabled),
  brandRefreshSkin: JSON.parse(reactRoot.dataset.brandRefreshSkin),
});
